import React from 'react';
import PropTypes from 'prop-types';
import { Headline4 } from '@cdm/quickenloans-library/lib';
import { testAttributes } from '../Constants';
import * as styles from '../ArticleMultipleChoiceCTA.module.scss';

const Tile = ({ item, handleSelectedTile, selectedTile }) => (
    <div
        className={`${styles.tile} ${item.id === selectedTile ? styles.selected : ''}`}
        data-testid={item.id}
        onClick={(event) => handleSelectedTile(event, item)}
        role="presentation"
    >
        <div className={styles.illustration}>
            {item.img && <img src={item.img} alt={item.title} />}
        </div>
        <div className={styles.textContent}>
            <Headline4 className="h4_bold">{item.title}</Headline4>
            {item.subtitle && (
                <span
                    className={styles.subtitle}
                    data-testid={
                        testAttributes.MULTIPLE_CTA_BODY_CONTENT_TEXT_SUBTITLE
                    }
                >
                    {item.subtitle}
                </span>
            )}
        </div>
    </div>
);

Tile.propTypes = {
    item: PropTypes.object.isRequired,
    handleSelectedTile: PropTypes.func.isRequired,
    selectedTile: PropTypes.string.isRequired,
};

export default Tile;
